"use client";

import styles from "./Callout.module.css";

const toneClass = {
  info: styles.toneInfo,
  warning: styles.toneWarning,
  danger: styles.toneDanger,
  success: styles.toneSuccess,
  neutral: styles.toneNeutral,
};

const DEFAULT_ICONS = {
  info: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  ),
  warning: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  danger: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  ),
  success: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  neutral: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  ),
};

export default function Callout({
  tone = "info",
  title,
  icon,
  children,
  className = "",
}) {
  const resolvedTone = toneClass[tone] ?? toneClass.info;
  const resolvedIcon = icon === false ? null : icon ?? DEFAULT_ICONS[tone] ?? DEFAULT_ICONS.info;

  const boxClasses = [styles.box, resolvedTone, className].filter(Boolean).join(" ");
  const bodyClasses = [styles.body, title ? "" : styles.bodyOnly].filter(Boolean).join(" ");

  return (
    <div className={boxClasses} role={tone === "danger" || tone === "warning" ? "alert" : undefined}>
      {resolvedIcon ? <span className={styles.iconWrapper}>{resolvedIcon}</span> : null}
      <div className={styles.content}>
        {title ? <div className={styles.title}>{title}</div> : null}
        <div className={bodyClasses}>{children}</div>
      </div>
    </div>
  );
}
